import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import i18n from '../../../i18next';

import ScheduledSettingsTable from './ScheduledSettingsTable';
import SettingsModalScreen from './SettingsModalScreen';

const ScheduledSettingsScreen = props => {

    const { saveBtnStyles } = props.styles;

    return (
        <Fragment>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <ScheduledSettingsTable {...props} />
                <Button
                    color='primary'
                    style={{ ...saveBtnStyles, alignSelf: 'flex-start' }}
                    onClick={() => props.toggle('Settings', null)}
                >
                    {i18n.t('screens:systemControlContainer.addScheduledSettings')}
                </Button>
            </div>

            {
                props.state.isSettingsOpen && <SettingsModalScreen {...props} />
            }

            <p style={{ fontSize: 14 }}>**{i18n.t('screens:systemControlContainer.tableInfoMsg')}</p>
        </Fragment>
    );
}

export default ScheduledSettingsScreen;


// WEBPACK FOOTER //
// ./src/components/systemControl/database/ScheduledSettingsScreen.js